export default (root: string) => ({
    runbookRuns: `${root}/runs`,
    runbookRun: (runbookRunId: string) => {
        const specificRoot = `${root}/runs/${runbookRunId}`;
        return {
            root: specificRoot,
        };
    },
});
